/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCustomer
 */
export interface MstCustomer {
    /**
     * 
     * @type {number}
     * @memberof MstCustomer
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCustomer
     */
    customerCompanyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    orgCustomerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    customerName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCustomer
     */
    internalTransferFlg: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    customerHojinNo: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    customerAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    customerGln: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    remarks: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomer
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomer
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    insertUser: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCustomer
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCustomer
     */
    deleteUser: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCustomer
     */
    deleteFlg: boolean | null;
}

/**
 * Check if a given object implements the MstCustomer interface.
 */
export function instanceOfMstCustomer(value: object): value is MstCustomer {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('customerCompanyId' in value) || value['customerCompanyId'] === undefined) return false;
    if (!('orgCustomerId' in value) || value['orgCustomerId'] === undefined) return false;
    if (!('customerName' in value) || value['customerName'] === undefined) return false;
    if (!('internalTransferFlg' in value) || value['internalTransferFlg'] === undefined) return false;
    if (!('customerHojinNo' in value) || value['customerHojinNo'] === undefined) return false;
    if (!('customerAddress' in value) || value['customerAddress'] === undefined) return false;
    if (!('customerGln' in value) || value['customerGln'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    return true;
}

export function MstCustomerFromJSON(json: any): MstCustomer {
    return MstCustomerFromJSONTyped(json, false);
}

export function MstCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCustomer {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'customerCompanyId': json['customer_company_id'],
        'orgCustomerId': json['org_customer_id'],
        'customerName': json['customer_name'],
        'internalTransferFlg': json['internal_transfer_flg'],
        'customerHojinNo': json['customer_hojin_no'],
        'customerAddress': json['customer_address'],
        'customerGln': json['customer_gln'],
        'remarks': json['remarks'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'insertUser': json['insert_user'],
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'deleteFlg': json['delete_flg'],
    };
}

export function MstCustomerToJSON(json: any): MstCustomer {
    return MstCustomerToJSONTyped(json, false);
}

export function MstCustomerToJSONTyped(value?: MstCustomer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'customer_company_id': value['customerCompanyId'],
        'org_customer_id': value['orgCustomerId'],
        'customer_name': value['customerName'],
        'internal_transfer_flg': value['internalTransferFlg'],
        'customer_hojin_no': value['customerHojinNo'],
        'customer_address': value['customerAddress'],
        'customer_gln': value['customerGln'],
        'remarks': value['remarks'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'delete_flg': value['deleteFlg'],
    };
}

